module.exports = __webpack_public_path__ + "static/Blue_Dragon-066118e86b50120b347385aa4c6f343f.jpg";